export default __webpack_public_path__ + "static/media/DJI_0989.MP4.00_01_35_12.Still004.0eb3670c.jpg";